import { render, staticRenderFns } from "./BankSelection.vue?vue&type=template&id=49ae7a38&scoped=true&"
import script from "./BankSelection.vue?vue&type=script&lang=js&"
export * from "./BankSelection.vue?vue&type=script&lang=js&"
import style0 from "./BankSelection.vue?vue&type=style&index=0&id=49ae7a38&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49ae7a38",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploymentSDD/build/corpmessengerwebapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('49ae7a38')) {
      api.createRecord('49ae7a38', component.options)
    } else {
      api.reload('49ae7a38', component.options)
    }
    module.hot.accept("./BankSelection.vue?vue&type=template&id=49ae7a38&scoped=true&", function () {
      api.rerender('49ae7a38', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Manda/BankSelection.vue"
export default component.exports